import type { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import { Trash2Icon, TriangleAlertIcon } from 'lucide-react';

import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';

type ConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  destructive?: boolean;
  loading?: boolean;
  confirmDisabled?: boolean;
  secondaryActions?: ReactNode;
};

export const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  destructive = false,
  loading = false,
  confirmDisabled = false,
  secondaryActions,
}: ConfirmationDialogProps) => {
  const { t } = useLocale();

  return (
    <SlideDialog
      open={open}
      onClose={onClose}
      title={title}
      onSave={onConfirm}
      saveText={confirmText ?? t('Confirm')}
      saveIcon={destructive ? <Trash2Icon /> : <TriangleAlertIcon />}
      saveColor={destructive ? 'error' : 'primary'}
      maxWidth="xs"
      loading={loading}
      saveDisabled={confirmDisabled}
      secondaryActions={secondaryActions}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="body2">{message}</Typography>
      </Box>
    </SlideDialog>
  );
};
